'use client';

import React, { useContext, useEffect, useMemo, useState } from 'react';
import { mutate } from 'swr';
import { miniCartsKey } from 'frontastic/hooks/useCart/helper';
import { AddToCartOverlayContextShape } from './types';

const AddToCartOverlayContext = React.createContext<AddToCartOverlayContextShape | undefined>(undefined);

const AddToCartOverlayProvider = ({ children }: React.PropsWithChildren) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [shouldDisplayMaxCartValueAlert, setShouldDisplayMaxCartValueAlert] = useState<boolean>(false);

  useEffect(() => {
    if (modalOpen) {
      mutate(miniCartsKey);
    }
  }, [modalOpen]);

  const context = useMemo(
    () => ({
      setModalOpen,
      modalOpen,
      shouldDisplayMaxCartValueAlert,
      setShouldDisplayMaxCartValueAlert,
    }),
    [
      setModalOpen,
      modalOpen,
      shouldDisplayMaxCartValueAlert,
      setShouldDisplayMaxCartValueAlert,
    ],
  );

  return <AddToCartOverlayContext.Provider value={context}>{children}</AddToCartOverlayContext.Provider>;
};

export default AddToCartOverlayProvider;

export const useAddToCartOverlay = () => {
  const context = useContext(AddToCartOverlayContext);
  if (!context) {
    throw new Error('useAddToCartOverlay must be used within an AddToCartOverlayProvider');
  }
  return context;
};
